<table class="table">
  <thead>
    <tr>
      <th>Mon</th>
      <th>Tue</th>
      <th>Wed</th>
      <th>Thu</th>
      <th>Fri</th>
      <th>Sat</th>
      <th>Sun</th>
    </tr>
  </thead>
  <tbody>
    @for (week of weeks; track week) {
      <tr>
        @for (day of week; track day) {
          <td [class.today]="day.isToday" [class.invalid]="day.isInvalid" [class.has-processing]="day.hasProcessing" tooltipPosition="top" [title]="day.isToday ? (day.count ? day.count + ' schedules to process this evening' : 'Nothing scheduled this evening') : ''">
            {{ day.date }}
            @if (day.count) {
              <span>{{ day.count }} to process</span>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
